import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { Dropdown } from 'react-bootstrap'
import { setSortAscending, setSortingType } from '../../actions/survey'

const mapStateToProps = ({ survey: { sortingType, sortAscending } }) => {
  return {
    sortingType,
    sortAscending,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSetSortingType: (type) => {
      dispatch(setSortingType(type));
    },
    onSetSortAscending: (ascending) => {
      dispatch(setSortAscending(ascending));
    },
  };
};

const SortingWidget = ({
  useTranslate,
  sortingType,
  sortAscending,
  onSetSortAscending,
  onSetSortingType,
  hideImportance
}) => {

  const setSorting = (type, asc) => {
    onSetSortAscending(asc);
    onSetSortingType(type)
  }

  const getActiveText = () => {
    if (sortingType === "byResult" && !sortAscending) {
      return useTranslate('data_vault.result_descending')
    } else if (sortingType === "byResult" && sortAscending) {
      return useTranslate('data_vault.result_ascending')
    } else if (sortingType === "byRating" && !sortAscending) {
      return useTranslate('data_vault.importance_descending')
    } else if (sortingType === "byRating" && sortAscending){
      return useTranslate('data_vault.importance_ascending')
    } else {
      return useTranslate('data_vault.result_descending')
    }
  }

  if (hideImportance && sortingType === "byRating") {
    setSorting("byResult", false);
  }

  return (
    <div className="sorting-container">
      <label htmlFor="selectSorting">{ useTranslate("data_vault.sort_dropdown_label") }</label>
      <div className={"dropdown-sorting"}>
        <Dropdown>
          <Dropdown.Toggle id="toggle-dropdown-sorting">
            { getActiveText() }
            <span className="ant-select-arrow" />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => setSorting("byResult", false)}
              className={`${sortingType === "byResult" && !sortAscending ? 'active' : ''}`}
            >
              { useTranslate('data_vault.result_descending') }
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => setSorting("byResult", true)}
              className={`${sortingType === "byResult" && sortAscending ? 'active' : ''}`}
            >
              { useTranslate('data_vault.result_ascending') }
            </Dropdown.Item>
            {!hideImportance &&
              <Fragment>
                <Dropdown.Item
                  onClick={() => setSorting("byRating", false)}
                  className={`${sortingType === "byRating" && !sortAscending ? 'active' : ''}`}
                >
                  { useTranslate('data_vault.importance_descending') }
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => setSorting("byRating", true)}
                  className={`${sortingType === "byRating" && sortAscending ? 'active' : ''}`}
                >
                  { useTranslate('data_vault.importance_ascending') }
                </Dropdown.Item>
              </Fragment>
            }
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(SortingWidget);


// WEBPACK FOOTER //
// ./src/components/ui/sorting-widget.js